exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabelaOrcamentos[data-v-39e63962]{width:100%}.tabelaOrcamentos td[data-v-39e63962],.tabelaOrcamentos th[data-v-39e63962]{border:1px solid #c3c3c3;padding:2px 4px}.tabelaOrcamentos thead tr[data-v-39e63962]{background:#f1f1f1;text-align:center;text-transform:uppercase}.tabelaOrcamentos .bloqueado[data-v-39e63962]{background:repeating-linear-gradient(45deg,#d4d4d4,#d4d4d4 10px,#d8d8d8 0,#d8d8d8 20px)}.msgErro[data-v-39e63962]{color:red;white-space:pre}", ""]);

// exports
